<div id="container">
  <mat-sidenav-container>
    <mat-sidenav [opened]="isSidePanelOpen()" mode="side">
      <app-navigation-bar></app-navigation-bar>
    </mat-sidenav>
    <mat-sidenav-content>
      <div id="grid">
        <app-action-bar></app-action-bar>
        <lib-filter-chips></lib-filter-chips>
        <ag-grid-angular
          class="ag-theme-cdx set-filter-custom"
          [rowData]="tableRowData | async"
          [gridOptions]="gridOptions"
          [localeText]="localeText | async"
          [statusBar]="statusBar"
          (gridReady)="onGridReady($event)"
          (rowDataUpdated)="onRowDataUpdate()"
        ></ag-grid-angular>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
